import { ERoles } from '@enums';

export interface IUser {
  uid: string;
  name: string;
  email: string;
  roles?: ERoles[];
  role?: ERoles;
  device_uuid: string;
  country_code: string;
}

export const hasRole = (user: IUser | undefined, role: ERoles): boolean => {
  if (!user) return false;

  if (Array.isArray(user.roles) && user.roles.includes(role)) {
    return true;
  }

  return user.role === role;
};
